module.exports = __webpack_public_path__ + "c150c34253e443c27ed26eff655b6c6e.svg";